























































































import {
  computed, defineComponent, onMounted, useRoute,
} from '@nuxtjs/composition-api';

import HTMLContent from '~/components/common/HTMLContent.vue';
import SwitchSaveBanner from '~/components/switch-save/components/Banner/Banner.vue';
import { CategoryTree } from '~/composables';
import { useHtmlRouter } from '~/composables/useHtmlRouter';
import { IMAGE_CONFIG } from '~/constants';
import {
  checkIsExclusiveLayout, checkIsSwitchSave, getBestsellerTitle,
  getBrandTitle as getCategoryBrandTitle, isPaperPage as isPaperCategory,
} from '~/helpers/categoryHelpers';
import CategoryBestsellers from '~/modules/catalog/category/components/CategoryBestsellers.vue';
import SearchWidget from '~/modules/catalog/category/components/views/SearchWidget.vue';

export default defineComponent({
  components: {
    CompleteBrandList: () => import('~/modules/catalog/category/components/CompleteBrandList.vue'),
    CategoryBestsellers,
    HTMLContent,
    SearchWidget,
    SwitchSaveBanner,
    ManufacturerPreloaded: () => import('~/modules/catalog/category/components/views/ManufacturerPreloaded/ManufacturerPreloaded.vue'),
    ContentBlocks: () => import('~/components/ContentBlocks.vue'),
    CategoryFaq: () => import('../CategoryFaq.vue'),
  },
  props: {
    category: {
      type: Object as () => CategoryTree,
      default: () => ({}),
      required: true,
    },
  },
  setup(props) {
    const route = useRoute();
    const { addDynamicRoutes } = useHtmlRouter();

    const { width, height } = IMAGE_CONFIG.sizes.brandLogo;
    const isInk = computed(() => route.value.path.includes('ink'));
    const isPaperPage = computed(() => isPaperCategory(props.category));
    const brandTitle = computed(() => getCategoryBrandTitle(props.category));
    const brandImage = computed(() => {
      if (!props.category.name) {
        return '';
      }

      const categoryName = props.category.name.toLowerCase().replace(' ', '-').replace(/-+$/, '');
      const imagePath = `${categoryName}/${width}x${height}/${categoryName}.png`;

      return `/media/wysiwyg/thumbnail/brand/${imagePath}`;
    });
    const isExclusiveLayout = computed(() => checkIsExclusiveLayout(props.category.url_path));
    const isSwitchSaveBanner = computed(() => checkIsSwitchSave(props.category.path));
    const bestSellingTitle = computed(() => getBestsellerTitle(props.category));
    const filteredBestsellers = computed(() => props.category.bestsellers.filter((item) => item.sku));

    onMounted(() => {
      addDynamicRoutes('.category-description');
    });

    return {
      isInk,
      isPaperPage,
      brandTitle,
      brandImage,
      filteredBestsellers,
      isExclusiveLayout,
      isSwitchSaveBanner,
      bestSellingTitle,
    };
  },
});
